'use client';

import { useMemo } from 'react';
import { Skeleton } from '@mokoboko/components';
import DOMPurify from 'isomorphic-dompurify';

import { replaceTermsTags, type TermsTagValues } from '@/helpers/terms';
import { TERMS_PROSE } from '@/lib/prose';
import type { ResolvedTerms } from '@/services/terms';

export const TermsDocumentContent = ({
  doc,
  tagValues,
}: {
  doc: ResolvedTerms;
  tagValues?: TermsTagValues;
}) => {
  const html = useMemo(
    () => DOMPurify.sanitize(replaceTermsTags(doc.content, tagValues)),
    [doc.content, tagValues]
  );

  return (
    <div className={TERMS_PROSE} dangerouslySetInnerHTML={{ __html: html }} />
  );
};

export const TermsSkeleton = () => (
  <div className="space-y-10">
    <div className="space-y-4">
      <Skeleton text="h1" className="sm:w-72" />
      <div className="space-y-2">
        <Skeleton text="body-sm" />
        <Skeleton text="body-sm" />
        <Skeleton text="body-sm" />
        <Skeleton text="body-sm" className="w-2/3" />
      </div>
    </div>
  </div>
);
